// Shared inline styles for onboarding pages.
// Kept as plain JS so the pages stay self-contained and never depend on the
// dashboard's Tailwind layer (which only loads inside the main shell).

export const onboardingShell = {
  minHeight: "100vh",
  background: "#ffffff",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: 48,
  paddingBottom: 48,
  paddingLeft: 16,
  paddingRight: 16,
  boxSizing: "border-box",
};

export const card = {
  background: "#ffffff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
  boxSizing: "border-box",
};

export const label = {
  display: "block",
  fontSize: 12,
  fontWeight: 600,
  color: "#374151",
  marginBottom: 6,
  textTransform: "none",
  letterSpacing: 0,
};

export const baseInput = {
  width: "100%",
  height: 44,
  border: "1px solid #D1D5DB",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 14,
  color: "#111827",
  outline: "none",
  boxSizing: "border-box",
  background: "#ffffff",
  transition: "border-color 0.15s ease, box-shadow 0.15s ease",
};

export const focusRing = {
  borderColor: "#059669",
  boxShadow: "0 0 0 3px rgba(5,150,105,0.12)",
};

export const primaryBtn = {
  width: "100%",
  height: 48,
  background: "#059669",
  color: "white",
  fontWeight: 700,
  fontSize: 15,
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  transition: "background-color 0.15s ease",
};

export const errorText = {
  color: "#DC2626",
  fontSize: 12,
  marginTop: 4,
};

export const helpText = {
  color: "#9CA3AF",
  fontSize: 11,
  marginTop: 4,
};

/** Useful for inputs whose focus state we manage with React state. */
export function inputStyle(focused) {
  return focused ? { ...baseInput, ...focusRing } : baseInput;
}
